import React from "react";
import { Building2, House, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LancezVotreProjet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="lancez-votre-projet" className="relative w-full py-24 overflow-hidden bg-primary text-primary-foreground">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564310/img/blueprint_overlay_pattern.png)] bg-cover bg-center opacity-10 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary via-transparent to-primary/80" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight font-sans text-white">Prêt à construire ?</h2>
        
        <p className="text-lg md:text-xl text-primary-foreground/80 mb-12 max-w-2xl mx-auto leading-relaxed">
          Que vous soyez un professionnel de l'immobilier ou un particulier avec un projet de vie, 
          nous avons l'expertise technique et l'accompagnement sur-mesure qu'il vous faut.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full max-w-3xl mx-auto">
          {}
          <div className="w-full sm:w-auto" data-index="0">
            <Button asChild size="lg" className="w-full sm:w-auto min-w-[240px] h-14 text-base font-semibold bg-accent text-accent-foreground hover:bg-accent/90 shadow-lg shadow-accent/20 border-0">
              <Link to="/contact">
                <Building2 className="mr-2 h-5 w-5" />
                Je suis un Promoteur
                <ArrowRight className="ml-2 h-4 w-4 opacity-70" />
              </Link>
            </Button>
          </div>

          {}
          <div className="w-full sm:w-auto" data-index="1">
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto min-w-[240px] h-14 text-base font-semibold bg-transparent border-2 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground hover:text-primary transition-colors">
              <Link to="/contact">
                <House className="mr-2 h-5 w-5" />
                Je suis un Particulier
                <ArrowRight className="ml-2 h-4 w-4 opacity-70" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}